import { createAction } from '@reduxjs/toolkit'

import {
  ActiveTablesTypes,
  IConvertedPlayerPrivacySettings,
  IConvertedSlotsLastWinsList,
  IGetSlotsLastWinsPayload,
} from 'shared/models/LastWins'
import { makeCommunicationActionCreator } from 'shared/utils/communication/actions/makeCommunicationActionCreator'
import { getReplacedTableType } from 'shared/utils/lastWins'

export const UPDATE_LAST_WINS_PAGE_SUCCESS = '@lastWins/UPDATE_LAST_WINS_PAGE_SUCCESS'
export const UPDATE_LAST_WINS_PAGE_SIZE_SUCCESS = '@lastWins/UPDATE_LAST_WINS_PAGE_SIZE_SUCCESS'

export const CHANGE_ACTIVE_WINS_TABLE_SUCCESS = '@lastWins/CHANGE_ACTIVE_WINS_TABLE_SUCCESS'

export const updateSlotsLastWinsPage = createAction<number>(UPDATE_LAST_WINS_PAGE_SUCCESS)
export const changeActiveWinsTable = createAction<ActiveTablesTypes>(CHANGE_ACTIVE_WINS_TABLE_SUCCESS)
export const updateSlotsLastWinsPageSize = createAction<number>(UPDATE_LAST_WINS_PAGE_SIZE_SUCCESS)

export const getSlotsLastWins = makeCommunicationActionCreator({
  loading: '@lastWins/GET_SLOTS_LAST_WINS_LOADING',
  success: '@lastWins/GET_SLOTS_LAST_WINS_SUCCESS',
  error: '@lastWins/GET_SLOTS_LAST_WINS_ERROR',
  reset: '@lastWins/GET_SLOTS_LAST_WINS_RESET',
})<IGetSlotsLastWinsPayload, IConvertedSlotsLastWinsList>(async ({
  deps: {
    extra: { api },
  },
  payload,
}) => {
  const updatedPayload = {
    ...payload,
    table_type: getReplacedTableType(payload.table_type),
  }

  const response = await api.lastWins.getSlotsLastWins(updatedPayload)

  return response.data
})

export const getPlayerPrivacySettings = makeCommunicationActionCreator({
  loading: '@lastWins/GET_PRIVACY_SETTINGS_LOADING',
  success: '@lastWins/GET_PRIVACY_SETTINGS_SUCCESS',
  error: '@lastWins/GET_PRIVACY_SETTINGS_ERROR',
  reset: '@lastWins/GET_PRIVACY_SETTINGS_RESET',
})<void, IConvertedPlayerPrivacySettings>(async ({
  deps: {
    extra: { api },
  },
}) => {
  const response = await api.lastWins.getPlayerPrivacySettings()

  return response.data
})
